<template>
  <div id="wrapper-box">
    <div class="home" id="wrapper">
      <p>Assessing fire safety in ro-ro passenger ships</p>
      <div class="home-box p-5 mx-auto">
        <p>
          <!--The firesafe I (2016) and Firesafe II (2018) studies were conducted by
          RISE, Bureau Veritas and Stena Line. The reports of both studies can
          be found and downloaded from
          <a href="www.emsa.europa.eu/firesafe.html"
            >www.emsa.europa.eu/firesafe.html</a
          >-->
          This is an interactive overview of the results of two important
          studies commissioned by EMSA to assess fire safety in ro-ro passenger
          ships. The Firesafe I and Firesafe II studies were conducted by RISE,
          Bureau Veritas and Stena Line. Each study explores the different
          stages involved in the outbreak and evolution of a fire on board a
          ro-ro passenger ship. For each, measures known as risk control options
          (RCO) are put forward and their effectiveness explored.
        </p>
      </div>
      <router-link
        to="/select"
        class="btn-1 d-block mx-auto mt-4 mb-3 transition scale-effect"
        >START</router-link
      >
      <router-link
        class="btn-2 d-block mx-auto mb-2 transition scale-effect"
        to="/download-reports"
      ></router-link>
      <router-link
        to="/ship-info"
        class="btn-3 d-block mx-auto transition scale-effect"
      ></router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  props: {
    msg: String
  },
  mounted: function() {
    // Vuex mutations
    this.$store.commit("setBackground", "blue-background");
    this.$store.commit("setFiresafeNumber", 0);
    this.$store.commit("toggleShip", true);
    this.$store.commit("toggleWaves", true);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
